import i18n from 'i18next';
import {ComponentsProvider} from 'platform/components';

import {ReactNode, useState, useEffect} from 'react';
import {useSelector} from 'react-redux';

import {defaultTo} from 'ramda';

import {useGetCurrenciesQuery} from '@dms/api/core';
import {selectActiveBranchId} from '@dms/api/features';
import {useGetLocaleConfigQuery} from '@dms/api/settings';
import {FocusControlProvider} from '@dms/shared';

import {DataGridContainer} from '../components/DataGridContainer/DataGridContainer';

type DataProviderWrapperProps = {
  children: ReactNode;
};

const isDev = process.env.ENV_TYPE === 'dev';
// isDev is needed if someone decided to create a stage/production tenant called "localhost"
const isLocal = window.location.hostname.includes('localhost') && isDev;

export const ComponentsProviderWrapper = (props: DataProviderWrapperProps) => {
  const branchId = useSelector(selectActiveBranchId);
  const {data: currenciesData} = useGetCurrenciesQuery();
  const {data: localeConfig} = useGetLocaleConfigQuery(undefined, {skip: !branchId});

  const [language, setLanguage] = useState(i18n.language);

  useEffect(() => {
    const handleLanguageChange = (lng: string) => {
      setLanguage(lng);
    };

    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, []);

  return (
    <DataGridContainer>
      <FocusControlProvider>
        <ComponentsProvider
          t={i18n.t}
          currencies={defaultTo([], currenciesData)}
          language={language}
          localeConfig={localeConfig}
          debug={isLocal && isDev}
        >
          {props.children}
        </ComponentsProvider>
      </FocusControlProvider>
    </DataGridContainer>
  );
};
